import { inject, provideAppInitializer } from '@angular/core';
import { EMPTY, catchError, of } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { PermissionsService } from './permissions.service';

export const PERMISSIONS_INITIALIZER = provideAppInitializer(() => {
  const authService = inject(AuthService);
  const permissionsService = inject(PermissionsService);

  return authService.isAuthenticated() ? permissionsService.getPermissions().pipe(catchError(() => of(0))) : EMPTY;
});
